import { gql } from "@apollo/client";

export const INSERT_REVIEW = gql`
    mutation gqlInsertReview($review: ReviewInput) {
        code: gqlInsertReview(review: $review)
    }
`;